'use strict';

module.exports = generated;

function generated(node) {
  var position = optional(optional(node).position);
  var start = optional(position.start);
  var end = optional(position.end);
  return !start.line || !start.column || !end.line || !end.column;
}

function optional(value) {
  return value && typeof value === 'object' ? value : {};
}